<div class="page hug-pre-engagement">
  <main class="mContent overflow-auto overflow-x-hidden">
    <app-section-loader [loading]="loading || isSavingLoader"></app-section-loader>
    <section class="pre-engage-header">
      <h2 class="pre-engage-header__title">
        {{lessonName}}
      </h2>
      <div class="pre-engage-header__buttons">
        <button mat-raised-button color="white" class="hug-main-button" (click)="tutorTipModalOpen(true)">
          <img src="../../../assets/assets/images/svg/info-blue.svg" alt="Info icon">
          Tutor Tips
        </button>
      </div>
    </section>

    <nav class="hug-psc-navigation">
      <div class="hug-psc-navigation__nav">
        <button (click)="onBackClick()">
          <p>Back</p>
          <img src="../../../assets/assets/images/svg/arrow-back.svg" alt="previous">
          <p>Passage</p>
        </button>
      </div>

      <div class="hug-psc-navigation__container">
        <h2 class="hug-h2 text-center text-primary" style="font-size: 30px;">
          After H.U.G lesson
        </h2>
      </div>

      <div class="hug-psc-navigation__nav invisible">
        <button>
          <p>Next</p>
        </button>
      </div>
    </nav>

    
    <form [formGroup]="updateStudentProgressGroup">
    <div class="hug-post-engagement-body text-center">

      <div formArrayName="passages">
      <div style="padding-top: 32px;" *ngFor="let _ of passageDetails; let i = index" [formGroupName]="i">

        <h2 class="text-primary">
          <span class="step-indicator">Step {{firstStepNumber + i}}:</span>
          Passage {{ i + 1 }} Reading: {{ passageDetails[i]?.passage_name || 'Unnamed Passage' }}
          <span class="text-danger">*</span>
        </h2>

        <h3 class="hug-text">
          How much progress did you and your student make on this passage?
        </h3>

        <mat-radio-group class="hug-radio-group justify-content-lg-center" formControlName="second_read_complete" (change)="setSecondReadComplete($event.value, i)">
          <div class="hug-custom-margin hug-custom-margin-lg">
            <div class="row">
              <div class="col-6 col-lg-3 col-md-3 col-sm-6 col-xs-6">
                <div class="hug-progress-container">
                  <div class="hug-icon mb-4 text-center">
                    <img src="assets/images/tutor/Unabletostart.svg" alt="Unable to start (comment why below)"
                      role="presentation" />
                  </div>
                  <div class="d-flex justify-content-center hug-radio-group">
                    <mat-radio-button [value]="1" (keydown.enter)="$event.preventDefault()">
                      Unable to start
                      <span class="d-block">(comment why below)</span>
                    </mat-radio-button>
                  </div>
                </div>
              </div>

              <div class="col-6 col-lg-3 col-md-3 col-sm-6 col-xs-6">
                <div class="hug-progress-container">
                  <div class="hug-icon mb-4 text-center">
                    <img src="assets/images/tutor/someprogress.svg" alt="Some progress" role="presentation" />
                  </div>
                  <div class="d-flex justify-content-center hug-radio-group">
                    <mat-radio-button [value]="2" (keydown.enter)="$event.preventDefault()">
                      Some
                      <span class="d-block">progress</span>
                    </mat-radio-button>
                  </div>
                </div>
              </div>

              <div class="col-6 col-lg-3 col-md-3 col-sm-6 col-xs-6">
                <div class="hug-progress-container">
                  <div class="hug-icon mb-4 text-center">
                    <img src="assets/images/tutor/firstattempt.svg" alt="First attempt completed" role="presentation" />
                  </div>
                  <div class="d-flex justify-content-center px-4 hug-radio-group">
                    <mat-radio-button [value]="3" (keydown.enter)="$event.preventDefault()">
                      First attempt
                      <span class="d-block">completed</span>
                    </mat-radio-button>
                  </div>
                </div>
              </div>

              <div class="col-6 col-lg-3 col-md-3 col-sm-6 col-xs-6">
                <div class="hug-progress-container">
                  <div class="hug-icon mb-4 text-center">
                    <img src="assets/images/tutor/secondattempt.svg" alt="Second attempt completed"
                      role="presentation" />
                  </div>
                  <div class="d-flex justify-content-center px-4 hug-radio-group">
                    <mat-radio-button [value]="4" (keydown.enter)="$event.preventDefault()">
                      Second attempt
                      <span class="d-block">completed</span>
                    </mat-radio-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-radio-group>
      </div>
      </div>

      <section class="hug-reading-pg">
        <h2 class="text-primary">
          <span class="step-indicator">Step 5:</span>
          Excitement About Reading
         <span class="text-danger">*</span>
        </h2>
        <h3>Are you more excited to read at home because of H.U.G.?</h3>
        <div class="hug-reading-pg__images">
          <div class="div-1">
            <img src="../../../../../assets/images/wild-robot.png" alt="book image">
            <!-- <img src="../../../../../assets/images/jamboard-book.png" alt="book image"> -->
          </div>
          <div class="div-2">
            <img src="../../../../../assets/images/dog-man.png" alt="book image">
          </div>
        </div>

        <mat-radio-group class="hug-radio-group hug-custom-margin hug-custom-margin-lg"
          aria-label="read_at_home" formControlName="read_at_home">
          <mat-radio-button [value]="1" (keydown.enter)="$event.preventDefault()">Yes</mat-radio-button>
          <mat-radio-button [value]="2" (keydown.enter)="$event.preventDefault()">No</mat-radio-button>
        </mat-radio-group>
      </section>

      <section class="hug-tutor-engagement">
        <div class="hug-container">
          <div class="hug-custom-margin">
            <h2 class="text-primary">
              <span class="step-indicator">Step 6:</span>
              Student Post-Lesson Engagement <span class="text-danger">*</span>
            </h2>
            <h3 class="hug-text">How did your learning go today?</h3>
          </div>
          <ul class="hug-tutor-smiley ">
            <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_second.value == 1
                " (click)="setMoodValue(1, 'mood_second')">
              <div class="hug-smiley hug-smiley--neutral">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">1</span>
              <span class="hug-tutor-smiley__text">Other</span>
            </li>
            <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_second.value == 2
                " (click)="setMoodValue(2, 'mood_second')">
              <div class="hug-smiley hug-smiley--neutral">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">2</span>
              <span class="hug-tutor-smiley__text">Not So Good</span>
            </li>
            <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_second.value == 3
                " (click)="setMoodValue(3, 'mood_second')">
              <div class="hug-smiley hug-smiley--neutral">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">3</span>
              <span class="hug-tutor-smiley__text">Okay</span>
            </li>
            <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_second.value == 4
                " (click)="setMoodValue(4, 'mood_second')">
              <div class="hug-smiley hug-smiley--happy">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">4</span>
              <span class="hug-tutor-smiley__text">Good</span>
            </li>
            <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_second.value == 5
                " (click)="setMoodValue(5, 'mood_second')">
              <div class="hug-smiley hug-smiley--veryHappy">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">5</span>
              <span class="hug-tutor-smiley__text">Awesome</span>
            </li>
          </ul>

          <h3 class="hug-h5 text-center hug-text">

          </h3>
          <div class="hug-custom-margin">
            <h2 class="text-primary">
              <span class="step-indicator">Step 7:</span>
              Tutor Engagement <span class="text-danger">*</span>
            </h2>
            <h3 class="hug-text">How would you rate your volunteer experience? </h3>
          </div>
          <ul class="hug-tutor-smiley">
            <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.volunteer_mood.value ==
                    1
                " (click)="setMoodValue(1, 'volunteer_mood'); onTerribleClick()">
              <div class="hug-smiley hug-smiley--neutral">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">1</span>
              <span class="hug-tutor-smiley__text">Other</span>
            </li>
            <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.volunteer_mood.value ==
                    2
                " (click)="setMoodValue(2, 'volunteer_mood')">
              <div class="hug-smiley hug-smiley--neutral">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">2</span>
              <span class="hug-tutor-smiley__text">Not So Good</span>
            </li>
            <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.volunteer_mood.value ==
                    3
                " (click)="setMoodValue(3, 'volunteer_mood')">
              <div class="hug-smiley hug-smiley--neutral">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">3</span>
              <span class="hug-tutor-smiley__text">Okay</span>
            </li>
            <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.volunteer_mood.value ==
                    4
                " (click)="setMoodValue(4, 'volunteer_mood')">
              <div class="hug-smiley hug-smiley--happy">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">4</span>
              <span class="hug-tutor-smiley__text">Good</span>
            </li>
            <li class="hug-tutor-smiley__card active" [class.active]="
                  updateStudentProgressGroup.controls.volunteer_mood.value ==
                    5
                " (click)="setMoodValue(5, 'volunteer_mood')">
              <div class="hug-smiley hug-smiley--veryHappy">
                <div class="hug-smiley__face">
                  <span class="hug-smiley__eyeLeft"></span>
                  <span class="hug-smiley__eyeRight"></span>
                  <div class="hug-smiley__mouth"></div>
                </div>
              </div>
              <span class="hug-tutor-smiley__name">5</span>
              <span class="hug-tutor-smiley__text">Awesome</span>
            </li>
          </ul>
        </div>
      </section>

      <section class="hug-tutor-confirm">
        <div class="hug-container">
          <h2 class="text-primary text-left">
              <span class="step-indicator">Step 8:</span>
              Tutor Comments
            </h2>
          <ng-container>
            <mat-form-field appearance="outline" class="hug-textarea">
              <textarea formControlName="comments" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="8" cdkAutosizeMaxRows="8" matInput placeholder="Please leave any comments about your H.U.G. experience today"></textarea>
            </mat-form-field>
          </ng-container>
        </div>
      </section>

      <button mat-raised-button color="primary" class="hug-main-button miro-btn mb-4" (click)="reviewEngagementForm()">
        Review Engagement Form
      </button>
    </div>
    </form>
  </main>

  <div class="modal" [ngClass]="{'active':tutorTipModal}" id="modalExample">
  <div class="modal__box">
    <div class="modal__header">
      <h2>Tutor Tips</h2>
      <button class="close" aria-label="Close" (click)="tutorTipModalOpen(false)">×</button>
    </div>
    <div class="modal__body">
      <p [innerHTML]="tutorTips"></p>
    </div>
  </div>
  </div>

  <footer class="hug-tutor-footer">
    <div class="hug-container">
      <p class="hug-copyright">© Help Us Grow Reading Program</p>
    </div>
  </footer>
</div>